import { client } from '../http';

export default {
  async saveActivationSurveyAnswers({ answers }) {
    return await client.post('/api/survey/activation', { answers });
  },
  async saveChurnSurveyAnswers({ customerId, subscriptionState, answers }) {
    return await client.post('/api/no-auth/survey/churn', { customerId, subscriptionState, answers });
  },
};



// WEBPACK FOOTER //
// ./src/api/SurveyApi.js